import responsiveBlocksConfig from './responsiveBlocksConfig'

export default {
    ...responsiveBlocksConfig,
    allowOnlyPublishRC: true,
    extensionsList: responsiveBlocksConfig.extensionsList.filter(extension => extension !== 'sectionOrder')
}
